export default {
  init() {
    function setCheckbox(elem) {
      if ($(elem).is(':checked')) {
        $(elem).prev('.custom-checkbox').addClass('checked');
      } else {
        $(elem).prev('.custom-checkbox').removeClass('checked');
      }
    }

    $(document).ready(function () {
      // apply custom checkbox on page ready
      $('input[type="checkbox"]').before('<span class="custom-checkbox">');
      $('input[type="checkbox"]').each(function () {
        setCheckbox($(this));
      });

      $('.scrollto').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: $($(this).attr('href')).offset().top}, 500);
      });

      $(document).on('click', '.modal-js', function (e) {
        e.preventDefault();
        fetch($(this).attr('href')).then(data => data.text())
          .then(data => {
            $('#modalContent').find('.modal-body').html(data);
            $('#modalContent').modal('toggle');
          });

      })
    });

// on input change, change custom checkbox
    $('body').on('change', 'input[type="checkbox"]', function () {
      setCheckbox($(this));
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js